export default {
  namespaced: true,
  state: {
    hasScrolledDown: false,
    stickyHeight: 0,
  },
  getters: {
    getHasScrolledDownState(state) {
      return state.hasScrolledDown;
    },
    getStickyHeight(state) {
      return state.stickyHeight;
    },
  },
  actions: {
    setHasScrolledDown: (context, data) => {
      context.commit("setHasScrolledDown", data);
    },
    setStickyHeight: (context, data) => {
      context.commit("setStickyHeight", data);
    },
  },
  mutations: {
    setHasScrolledDown: (state, bool) => {
      state.hasScrolledDown = bool;
    },
    setStickyHeight: (state, number) => {
      state.stickyHeight = number;
    },
  },
};
